import { render } from "./task.vue?vue&type=template&id=f0684308&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"

import "./task.vue?vue&type=style&index=0&id=f0684308&scoped=true&lang=css"

import exportComponent from "D:\\Code\\mt\\Agent\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0684308"]])

export default __exports__